import PropTypes from 'prop-types';

import { MobileDrawerStyled } from './styles';

export default function MobileDrawer({ open = true, children, handleClose, ...rest }) {
  return (
    <MobileDrawerStyled
      anchor="bottom"
      onClose={handleClose}
      open={open}
      role="dialog"
      {...rest}
    >
      {children}
    </MobileDrawerStyled>
  );
}

MobileDrawer.propTypes = {
  children: PropTypes.node.isRequired,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool
};
